"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const FacilitiButton = () => {
    return ((0, jsx_runtime_1.jsx)(styles_1.Button, { type: "button", "data-faciliti-popin": true, "aria-label": "FACIL'iti : Adapt the display", title: "FACIL'iti : Adapt the display", children: (0, jsx_runtime_1.jsx)("img", { loading: "lazy", width: "50", height: "50", src: "https://media.veepee.com/v1/media/4e280789-ea11-4502-9de3-48be2af3204b", alt: "FACIL'iti" }) }));
};
exports.default = FacilitiButton;
